import { Tag as BluBlocksTag } from "@bluframe/blublocks"
import styled from "styled-components"

export const StyledTag = styled(BluBlocksTag)`
  padding: 8px 14px;
`
